import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DistributorNavbar from "./DistributorComp/DistributorNavbar";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../component/Baseurl";
import DataTable from "react-data-table-component"; // Import React Data Table
import { Link } from "react-router-dom";


function AllAgentDistributor() {
  const navigate = useNavigate();
  const distributor_id = localStorage.getItem("distributor_id");
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    if (!distributor_id) {
      Swal.fire("Error", "Distributor ID not found", "error");
      return;
    }

    const fetchAgents = async () => {
      try {
        const response = await axios.get(`${baseurl}getAgentsByDistributorId/${distributor_id}`);
        setAgents(response.data.agents);
      } catch (error) {
        console.error("Error fetching agents:", error);
        Swal.fire("Error", "Failed to fetch agents", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchAgents();
  }, [distributor_id]);

  // Function to render status badge
  const renderStatusBadge = (status) => {
    return (
      <span className={`badge ${status === "active" ? "bg-success" : "bg-danger"}`}>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    );
  };

  // Columns for the data table
  const columns = [
    { 
      name: "Sr. No.", 
      selector: (row, index) => index + 1, 
      sortable: false, 
      width: "80px" 
    },
    { name: "Unique ID", selector: (row) => row.agent_unique_id, sortable: true },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Phone", selector: (row) => row.phone, sortable: true },
    { name: "City", selector: (row) => row.city, sortable: true },
    { name: "State", selector: (row) => row.state, sortable: true },
    { name: "Country", selector: (row) => row.country, sortable: true },
    { 
      name: "Status", 
      selector: (row) => row.agent_status, 
      sortable: true, 
      cell: (row) => renderStatusBadge(row.agent_status) 
    },
    { 
      name: "Add Top-Up", 
      cell: (row) => (
        <Link to={`/state-head/agent-topup/${row.id}`} className="btn3 btn-primary text-white">
        Add  Top-Up
        </Link>
      ), 
      ignoreRowClick: true, 
      allowOverflow: true, 
      button: true 
    },
  ];
  

  // Filtered agents based on search input
  const filteredAgents = agents.filter(
    (agent) =>
      agent.name.toLowerCase().includes(filterText.toLowerCase()) ||
      agent.email.toLowerCase().includes(filterText.toLowerCase()) ||
      agent.phone.toLowerCase().includes(filterText.toLowerCase()) ||
      agent.city.toLowerCase().includes(filterText.toLowerCase()) ||
      agent.state.toLowerCase().includes(filterText.toLowerCase()) ||
      agent.country.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <>
      <DistributorNavbar />
      <div className="bgagent pt-4">
        <div className="container-fluid">
          <div className="crdmain">
            <h2 className="title text-start">All Agents/Distributors</h2>

            <div className="row g-2 mt-1 mb-4 justify-content-center">
              <div className="col-md-12 p-2">
                <div className="ag1 p-2">
                  <input
                    type="text"
                    className="form-control mb-3 input1"
                    placeholder="Search agents..."
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />

                  <DataTable
                    columns={columns}
                    data={filteredAgents}
                    progressPending={loading}
                    pagination // Enable pagination
                    highlightOnHover
                    striped
                    noDataComponent="No agents found"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllAgentDistributor;
